module.exports = __webpack_public_path__ + "static/media/latex-allergy.bb80770f.svg";